export class SetLanguage {
  static readonly type = '[Language] Set Language';
  constructor(public language: string) {}
}
export class DisplayAvailableLanguages {
  static readonly type = '[Language] Get Available Languages';
}
